import { NgClass, NgForOf, NgIf, TitleCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, DoCheck, Input, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TextService } from '~app/services';

@Component({
    selector: 'ciao-field-error-list',
    imports: [NgIf, NgForOf, TitleCasePipe, NgClass],
    templateUrl: './field-error-list.component.html',
    styleUrl: './field-error-list.component.less'
})
export class FieldErrorListComponent implements DoCheck {
  @Input() control: AbstractControl;
  textService = inject(TextService);
  private cdr = inject(ChangeDetectorRef);
  list: string[] = [];
  visible = false;

  // Need to override because we can't just... detect when another control has been touched, and transmit it over.
  // That should become available in Angular 18.
  // https://github.com/angular/angular/issues/10887
  /** Override the untouched attribute and show anyways.  Only makes changes if set to true.  If set to false, this will do nothing. */
  @Input() forceShow?: boolean;

  ngDoCheck(): void {
    const shouldShow = this.control?.invalid && (this.control?.touched || this.control?.dirty || this.forceShow);
    if (shouldShow !== this.visible) {
      this.visible = shouldShow;
      this.updateList();
      this.cdr.markForCheck();
    } else if (shouldShow) {
      this.updateList();
    }
  }

  private updateList(): void {
    const errors = this.control?.errors;
    if (!errors) {
      this.list = [];
      return;
    }
    this.list = Object.keys(errors).map((key) =>
      this.textService.getValidationErrorText(key, errors[key])
    );
  }
}
